/**
 * @memberOf loavies.models.listing
 * @constructor
 */
export class ListingDiscountModel {
  /**
   * @param {number} discountPercentage
   * @param {loavies.models.base.PriceModel} originalPrice
   */
  constructor({
    discountPercentage,
    originalPrice,
  }) {
    /** @type {number} */
    this.discountPercentage = discountPercentage

    /** @type {loavies.models.base.PriceModel} */
    this.originalPrice = originalPrice
  }
}
